(() => {
  const navigationNode = document.getElementById('GearonimoPreparedNavigation');
  if (!navigationNode) return;

  let navigation = [];
  try {
    navigation = JSON.parse(navigationNode.textContent || '[]');
  } catch {
    return;
  }

  const closeDesktopItem = (navItem) => {
    if (!navItem) return;
    window.clearTimeout(navItem._preparedCloseTimer);
    navItem.classList.remove('is-open');
    navItem.querySelector('.primary-nav__link')?.setAttribute('aria-expanded', 'false');
  };

  const closeDesktopItems = (currentItem) => {
    document.querySelectorAll('.primary-nav__item.is-open').forEach((navItem) => {
      if (navItem === currentItem) return;
      closeDesktopItem(navItem);
    });
  };

  const openDesktopItem = (navItem) => {
    if (!navItem) return;
    window.clearTimeout(navItem._preparedCloseTimer);
    closeDesktopItems(navItem);
    navItem.classList.add('is-open');
    navItem.querySelector('.primary-nav__link')?.setAttribute('aria-expanded', 'true');
  };

  const makeAnchorFromControl = (control, item) => {
    if (!control || control.tagName === 'A' || !item?.suggestedUrl) return control;
    const link = document.createElement('a');
    Array.from(control.attributes).forEach((attribute) => {
      if (attribute.name === 'type') return;
      link.setAttribute(attribute.name, attribute.value);
    });
    link.href = item.suggestedUrl;
    link.textContent = control.textContent || item.label;
    control.replaceWith(link);
    return link;
  };

  const patchDesktopNavigation = () => {
    const desktopNav = document.querySelector('[data-prepared-nav="desktop"]');
    if (!desktopNav) return;

    Array.from(desktopNav.children).forEach((navItem, index) => {
      const item = navigation[index];
      const hasDropdown = Array.isArray(item?.groups) && item.groups.length > 0;
      if (!hasDropdown || !item.suggestedUrl) return;

      const directChild = Array.from(navItem.children).find((child) => (
        child.classList && child.classList.contains('primary-nav__link')
      ));
      const topLink = makeAnchorFromControl(directChild, item);
      if (!topLink) return;

      topLink.href = item.suggestedUrl;
      topLink.classList.add('primary-nav__link--toggle');
      topLink.setAttribute('aria-haspopup', 'true');
      if (!topLink.hasAttribute('aria-expanded')) topLink.setAttribute('aria-expanded', 'false');

      if (!navItem.dataset.categoryLinkPatched) {
        topLink.addEventListener('focus', () => openDesktopItem(navItem));
        topLink.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          closeDesktopItem(navItem);
          topLink.blur();
        });

        navItem.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (navItem.matches(':focus-within') || navItem.matches(':hover')) return;
            closeDesktopItem(navItem);
          }, 0);
        });
        navItem.dataset.categoryLinkPatched = 'true';
      }
    });
  };

  const patchMobileNavigation = () => {
    const mobileNav = document.querySelector('[data-prepared-nav="mobile"]');
    if (!mobileNav) return;

    Array.from(mobileNav.children).forEach((navItem, index) => {
      const item = navigation[index];
      const hasDropdown = Array.isArray(item?.groups) && item.groups.length > 0;
      if (!hasDropdown || !item.suggestedUrl || navItem.tagName !== 'DETAILS') return;

      const body = navItem.querySelector('.mobile-menu__group-body');
      if (!body || body.querySelector('[data-mobile-all-category]')) return;

      const allLabel = `All ${item.label}`;
      const existingAllLink = Array.from(body.children).find((child) => (
        child.textContent?.trim() === allLabel && child.getAttribute('href') === item.suggestedUrl
      ));
      if (existingAllLink) {
        existingAllLink.dataset.mobileAllCategory = 'true';
        return;
      }

      const link = document.createElement('a');
      link.href = item.suggestedUrl;
      link.className = 'mobile-menu__heading';
      link.dataset.mobileAllCategory = 'true';
      link.textContent = allLabel;
      body.prepend(link);
    });
  };

  const patchNavigation = () => {
    patchDesktopNavigation();
    patchMobileNavigation();
    const panel = document.querySelector('[data-prepared-nav="mobile"]');
    if (panel && !panel.querySelector('[data-mobile-category-close]')) {
      const close = document.createElement('button');
      close.type = 'button';
      close.dataset.mobileCategoryClose = '';
      close.setAttribute('aria-label', 'Close category menu');
      close.textContent = '×';
      panel.append(close);
      close.addEventListener('click', () => {
        const menu = panel.closest('details');
        panel.querySelectorAll('details[open]').forEach(group => { group.open = false; });
        if (menu) { menu.open = false; menu.querySelector('summary')?.focus({preventScroll:true}); }
      });
      const style = document.createElement('style');
      style.textContent = '[data-mobile-category-close]{display:none}@media(max-width:990px){[data-prepared-nav="mobile"]{padding-top:52px!important}[data-mobile-category-close]{display:flex;align-items:center;justify-content:center;position:absolute;top:8px;right:10px;width:36px;height:36px;padding:0;border:1px solid #d9d0c4;border-radius:50%;background:#f7f4ee;color:#242321;font-size:26px;line-height:1;cursor:pointer;z-index:5}[data-mobile-category-close]:focus-visible{outline:2px solid #ea4600;outline-offset:3px}}';
      document.head.append(style);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchNavigation, { once: true });
  } else {
    patchNavigation();
  }

  window.addEventListener('load', patchNavigation, { once: true });
})();
